import React from "react";
import { useNavigate } from "react-router-dom";
import PageShell from "@/components/PageShell";
import { Button } from "@/components/ui/button";
import { XCircle } from "lucide-react";

const CheckoutCancel = () => {
  const navigate = useNavigate();
  return (
    <PageShell>
      <section className="max-w-xl mx-auto px-6 py-20 text-center" data-testid="checkout-cancel-page">
        <div className="w-16 h-16 mx-auto rounded-full bg-amber-100 grid place-items-center">
          <XCircle className="w-8 h-8 text-amber-700" />
        </div>
        <h1 className="font-heading text-3xl text-[#222222] mt-6">تم إلغاء عملية الدفع</h1>
        <p className="text-[#5E5C58] mt-2">
          لم يتم تأكيد الحجز. يمكنك المحاولة مرة أخرى في أي وقت.
        </p>
        <div className="mt-8 flex justify-center gap-3">
          <Button
            onClick={() => navigate("/services")}
            className="rounded-full bg-[#0A4D3C] hover:bg-[#063A2D] text-white px-8 h-11"
          >
            العودة للخدمات
          </Button>
          <Button
            onClick={() => navigate("/dashboard")}
            variant="outline"
            className="rounded-full border-[#E5E1D8] px-8 h-11"
          >
            حسابي
          </Button>
        </div>
      </section>
    </PageShell>
  );
};

export default CheckoutCancel;
